import { useEffect, useState } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const row = { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 };
const lbl = { width: 130, fontSize: 13, fontWeight: 600 };

export default function TransfertModal({ onClose, onValider, codeNature, showPopup }) {
  const [mode, setMode] = useState("vers");
  const [regions, setRegions] = useState([]);
  const [bureaux, setBureaux] = useState([]);
  const [reg, setReg] = useState("");
  const [bur, setBur] = useState("");
  const [noSeq, setNoSeq] = useState("");

  useEffect(() => {
    axios.get(`${API}/reference/regions`, { withCredentials: true })
      .then(r => setRegions(r.data || []))
      .catch(() => setRegions([]));
  }, []);

  useEffect(() => {
    setBur("");
    if (!reg) { setBureaux([]); return; }
    axios.get(`${API}/reference/bureaux-by-region`, {
      params: { region: reg, include_all: true }, withCredentials: true,
    })
      .then(r => setBureaux(r.data || []))
      .catch(() => setBureaux([]));
  }, [reg]);

  const handleOk = () => {
    // Parité legacy FrmTrans BtnOK_Click (Mega procès : nature X/Y/Z → région 95)
    const nat = (codeNature || "").trim().toUpperCase();
    if (mode === "de" && ["X", "Y", "Z"].includes(nat.charAt(0)) && reg !== "95") {
      showPopup?.("Vous devez choisir le code de transfert CSJ (95) pour la nature Mega procès.",
                  "warning", "Mega Procès");
      return;
    }
    if (!reg || !bur || (mode === "de" && !noSeq.trim())) {
      showPopup?.("Veuillez remplir les cases vides\n        Merci !", "warning", "Transfert");
      return;
    }
    const regLabel = `${reg} ${(regions.find(r => r.code === reg)?.description || "").trim()}`.trim();
    const burLabel = `${bur} ${(bureaux.find(b => b.code === bur)?.bureau || "").trim()}`.trim();
    onValider({ mode, reg, bur, regLabel, burLabel, noSeq: noSeq.trim() });
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 }}
         onClick={onClose}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 520, maxWidth: "94vw" }}
           onClick={e => e.stopPropagation()}
           data-testid="transfert-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15,
                      display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>{mode === "vers" ? "TRANSFERT VERS" : "TRANSFERT EN PROVENANCE DE"}</span>
          <button className="win-modal-close" onClick={onClose} data-testid="transfert-btn-x">×</button>
        </div>
        <div style={{ padding: 20, fontSize: 14 }}>
          <div style={{ ...row, marginBottom: 18 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
              <input type="radio" name="transfert-mode" checked={mode === "vers"}
                     onChange={() => setMode("vers")} data-testid="transfert-mode-vers" />
              Transfert vers
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", marginLeft: 20 }}>
              <input type="radio" name="transfert-mode" checked={mode === "de"}
                     onChange={() => setMode("de")} data-testid="transfert-mode-de" />
              Transfert en provenance de
            </label>
          </div>
          {mode === "de" && (
            <div style={row}>
              <span style={lbl}>No séquence :</span>
              <input className="win-input" value={noSeq}
                     onChange={e => setNoSeq(e.target.value)}
                     placeholder="#########-##" maxLength={12}
                     style={{ width: 160, fontSize: 13 }}
                     data-testid="transfert-noseq" />
            </div>
          )}
          <div style={row}>
            <span style={lbl}>Région :</span>
            <select className="win-input" value={reg} onChange={e => setReg(e.target.value)}
                    style={{ flex: 1, fontSize: 13 }} data-testid="transfert-region">
              <option value=""></option>
              {regions.map(r => (
                <option key={r.code} value={r.code}>{r.code} {r.description}</option>
              ))}
            </select>
          </div>
          <div style={row}>
            <span style={lbl}>Bureau :</span>
            <select className="win-input" value={bur} onChange={e => setBur(e.target.value)}
                    disabled={!reg}
                    style={{ flex: 1, fontSize: 13 }} data-testid="transfert-bureau">
              <option value=""></option>
              {bureaux.map(b => (
                <option key={b.code} value={b.code}>{b.code} {b.bureau}</option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button className="win-btn" onClick={onClose} data-testid="transfert-btn-annuler">Annuler</button>
            <button className="win-btn" onClick={handleOk} style={{ fontWeight: "bold" }}
                    data-testid="transfert-btn-ok">OK</button>
          </div>
        </div>
      </div>
    </div>
  );
}
